export type EnterprisePricingTier = {
    readonly at: number;
    readonly above: number;
};

export type EnterprisePricingTierAccumulatedPrice = {
    readonly at: number;
    readonly above: number;
    readonly prevTierAccumulatedPrice: number;
};

export type EnterprisePriceCalculations = {
    readonly annualPrice: string;
    readonly annualPricePerUser: string;
    readonly monthlyPricePerUser: string;
};

export type FlatRatePricing = {
    monthly: number;
    annually: number;
};
